import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import rCoin from "../../assets/images/rcoin.png";
import useTranslation from "../../hooks/useTranslation";

// Parsed as local midnight: `new Date("2026-10-08")` shifts a day back for
// viewers west of Greenwich.
const dayLabel = (value, locale) => {
  const [y, m, d] = String(value || "").split("-").map(Number);
  if (!y || !m || !d) return "";
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(new Date(y, m - 1, d));
};

const DailyIncome = () => {
  const { t } = useTranslation();
  const { hostHitory } = useSelector((state) => state.history);
  // Latin digits in every language, so the ledger stays comparable across locales.
  const languageCode = useSelector(
    (state) => state.language?.selectedLanguageCode,
  );
  const locale = `${languageCode || "en"}-u-nu-latn`;
  const navigate = useNavigate();

  const handleOpenHistory = (data) => {
    navigate("/host/historyInfo", { state: data?.date });
  };

  return (
    <div style={{ padding: "16px", maxWidth: "500px", margin: "0 auto" }}>
      {hostHitory?.length > 0 ? (
        hostHitory.map((data, index) => (
          <div 
            key={index}
            role="button"
            tabIndex={0}
            onClick={() => handleOpenHistory(data)}
            onKeyDown={(e) => e.key === "Enter" && handleOpenHistory(data)}
            style={{
              background: "var(--mx-surface)",
              border: "1px solid var(--mx-border)",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "12px",
              cursor: "pointer"
            }}
          >
            {/* Single row with date and income */}
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center" 
            }}>
              <div>
                <div style={{ color: "var(--mx-accent)", fontSize: "14px", marginBottom: "4px" }}>
                   {t("date")}
                </div>
                <div style={{ color: "var(--mx-text)", fontSize: "14px" }}>
                  {dayLabel(data?.date, locale) || t("na")}
                </div>
              </div>
              
              <div style={{ textAlign: "end" }}>
                <div style={{ color: "var(--mx-accent)", fontSize: "14px", marginBottom: "4px" }}>
                  {t("income")}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <img src={rCoin} alt="R Coin" height={18} width={18} />
                  <span style={{ color: "var(--mx-accent)", fontSize: "16px", fontWeight: "600" }}>
                    {Number(data?.totalRCoin || 0).toLocaleString(locale)}
                  </span>
                </div>
              </div>

              <svg
                className="row-chevron"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--mx-muted)"
                strokeWidth="2"
                aria-hidden="true"
                style={{ flexShrink: 0, alignSelf: "center" }}
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>
        ))
      ) : (
        <div style={{ 
          textAlign: "center", 
          padding: "40px", 
          color: "var(--mx-text-2)",
          fontSize: "16px",
          background: "transparent",
          borderRadius: "12px",
          // border: "1px solid var(--mx-border)"
        }}>
         {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default DailyIncome;
